import { Button }               from '@/components/ui/button';
import { Field }                from '@/components/ui/field';
import { NativeSelect }         from '@chakra-ui/react';
import { Stack }                from '@chakra-ui/react';
import { Text }                 from '@chakra-ui/react';
import { useForm }              from 'react-hook-form';
import { useTranslation }       from 'react-i18next';
import ContactModel             from '@/models/services/network/ContactModel';
import { Box }                  from '@chakra-ui/react';
import ContactContactGroupModel from '@/models/services/network/ContactContactGroupModel';
import EntityModel              from '@/models/services/fondations/EntityModel';
import ApiCollection            from '@widesk-core/models/ApiCollection';
import ContactGroupModel        from '@/models/services/network/ContactGroupModel';
import { toaster }             from '@/components/ui/toaster';

interface IEntityAssignManagerFormProps {
	entity: EntityModel;
	assignableContacts: ContactModel[];
	onSuccess:          () => Promise<void>;
	onClose:            () => void;
}

interface FormValues {
	contactUrn: string;
}

const EntityAssignManagerForm = ({ entity, assignableContacts, onSuccess, onClose }: IEntityAssignManagerFormProps) => {
	const { t } = useTranslation();
	const { formState: { isSubmitting }, handleSubmit, register } = useForm<FormValues>();

	const onSubmit = handleSubmit(async (values) => {
		try {
			const contactGroupCollection = await new ApiCollection(ContactGroupModel).list();
			const managerContactGroup = contactGroupCollection.find(cg => cg.reference === 'manager');
			await new ContactContactGroupModel().patch({
				sourceUrn: entity.urn,
				contact: values.contactUrn,
				contactGroup: managerContactGroup?.urn,
			});
			toaster.create({
				title: t('pages.entity.managers.modals.assign.messages.success'),
				type: 'success',
			});
			await onSuccess();
		} catch {
			toaster.create({
				title: t('pages.entity.managers.modals.assign.messages.error'),
				type: 'error',
			});
		}
	});

	if (assignableContacts.length === 0) {
		return (
			<Box py="10px">
				<Text fontSize="14px" color="gray.500">
					{t('pages.entity.managers.modals.assign.empty')}
				</Text>
			</Box>
		);
	}

	return (
		<form onSubmit={onSubmit}>
			<Stack gap="20px" marginTop="10px">
				<Field
					label={<Text className="poppins-semibold" fontSize="14px" fontWeight="bold">{t('pages.entity.managers.modals.assign.contact')}</Text>}
					required
				>
					<NativeSelect.Root size="sm" width="100%">
						<NativeSelect.Field {...register('contactUrn', { required: true })}>
							{assignableContacts.map(contact => (
								<option key={contact.urn} value={String(contact.urn)}>
									{contact.fullName} — {contact.email}
								</option>
							))}
						</NativeSelect.Field>
						<NativeSelect.Indicator />
					</NativeSelect.Root>
				</Field>
			</Stack>

			<Box display="flex" gap="10px" marginTop="30px">
				<Button variant="outline" onClick={onClose} flex="1">
					{t('app.actions.cancel')}
				</Button>
				<Button variant="solid" type="submit" loading={isSubmitting} flex="1">
					{t('pages.entity.managers.modals.assign.submit')}
				</Button>
			</Box>
		</form>
	);
};

export default EntityAssignManagerForm;
